import { combineReducers } from 'redux';
import {
  createStatusReducers,
  createMultipleLifeCycleConstants,
  createReducer,
} from 'store/utils/reducerHelpers'
import types from './types'
import typesTheme from 'store/theme/types'
import { initialPreferences } from 'helpers/initialState'

const PREFERENCES = createMultipleLifeCycleConstants(types)
const THEME = createMultipleLifeCycleConstants(typesTheme)

const data = createReducer(
  initialPreferences,
  {
    [PREFERENCES.fetchPreferences.success]: (
      (state, action) => action.payload
    ),
    [THEME.fetchTheme.success]: (
      (state, action) => action.payload.preferences  || state
    )
  }
)

const statusReducers = createStatusReducers(types)

export default combineReducers({
  data,
  ...statusReducers,
})



// WEBPACK FOOTER //
// ./src/store/preferences/reducer.js